import { IOpinion } from '../../entities/opinions.entity';
import { OpinionsApi } from '../api/opinions.api';
import {
  fetchOpinionsFailed,
  fetchOpinionsRequest,
  fetchOpinionsSucceeded,
} from '../slices/opinions.slice';

import { AxiosResponse } from 'axios';
import { normalize, schema } from 'normalizr';
import { IOrganization } from 'organization';
import { IPerson } from 'person';
import { Dispatch } from 'redux';
import { IView } from 'shared-entities/pagination.entity';
import { AppThunk, IAppState } from 'store';

export const getOpinionsReceivedThunk = (params?: {
  [key: string]: string | number;
}): AppThunk<
  Promise<{
    [key: string]: IOpinion<IPerson, IOrganization>;
  }>
> => async (dispatch: Dispatch<any>, getState: () => IAppState) => {
  let response: AxiosResponse<{
    results: IOpinion<IPerson, IOrganization>[];
    view: IView;
  }> = null;
  dispatch(fetchOpinionsRequest({ key: 'listReceived' }));
  try {
    response = await OpinionsApi.getAll(params);
    const opinionsSchema = new schema.Entity('opinions');
    const {
      entities: { opinions },
    } = normalize(response.data.results, [opinionsSchema]);

    dispatch(
      fetchOpinionsSucceeded({
        list: opinions,
        view: response.data.view,
        key: 'listReceived',
        type: 'received',
      }),
    );
    return opinions;
  } catch (err) {
    const { name, response: responseError, stack, isAxiosError } = err;
    const error = {
      isAxiosError,
      message: responseError?.data?.message,
      name,
      code: responseError?.data?.statusCode,
      stack,
    };
    // - Fetch failed, set error
    dispatch(
      fetchOpinionsFailed({
        key: 'listReceived',
        error,
      }),
    );
    throw error;
  }
};
